import { render, staticRenderFns } from "./AsistenteDrawer.vue?vue&type=template&id=580de1dd&scoped=true&"
import script from "./AsistenteDrawer.vue?vue&type=script&lang=js&"
export * from "./AsistenteDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AsistenteDrawer.vue?vue&type=style&index=0&id=580de1dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580de1dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VNavigationDrawer,VProgressCircular,VSpacer,VTextField,VTextarea,VTooltip})
